var map = {
	"./fonts/Uni Sans Heavy.otf": "221c",
	"./fonts/Uni Sans Thin.otf": "b776",
	"./images/children.jpg": "c3a9",
	"./images/children_1.jpg": "9b55",
	"./images/eloadas.jpg": "dd65",
	"./images/eu_info.png": "d5a1",
	"./images/tabor.jpg": "aa9c",
	"./images/vizsgalat.jpg": "a03d",
	"./logo.png": "cf05",
	"./osszefoglalas.pdf": "5d99",
	"./slider/1.jpg": "01d7",
	"./slider/2.jpg": "058d",
	"./slider/3.jpg": "97e7",
	"./slider/viadukt.jpg": "93e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";